import { AddonFeature, useAddon } from './use-addon';
import { useIsAccountInEnterpriseBillingType, useIsAccountInPremiumBillingType } from './use-enterprise';
export const useHasAccessToInvoicingApprovalChains = ()=>{
    const hasInvoiceAddon = useAddon(AddonFeature.InvoiceApprovalChains);
    const isAccountInEnterpriseBillingType = useIsAccountInEnterpriseBillingType();
    return isAccountInEnterpriseBillingType || hasInvoiceAddon;
};
export const useHasAccessToInvoicing = ()=>{
    const hasInvoiceAddon = useAddon(AddonFeature.Invoice);
    const isAccountInEnterpriseBillingType = useIsAccountInEnterpriseBillingType();
    const isAccountInPremiumBillingType = useIsAccountInPremiumBillingType();
    return isAccountInEnterpriseBillingType || isAccountInPremiumBillingType || hasInvoiceAddon;
};
export const useHasAccessToBillingSchedule = ()=>{
    const hasAddon = useAddon(AddonFeature.BillingSchedule);
    const isAccountInEnterpriseBillingType = useIsAccountInEnterpriseBillingType();
    return isAccountInEnterpriseBillingType || hasAddon;
};
